var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"candidate-cursor fixed pointer-events-none",style:({
    visibility: _vm.dragging ? null : 'hidden',
    top: _vm.posY - _vm.deltaY + 'px',
    left: _vm.posX - _vm.deltaX + 'px'
  }),attrs:{"draggable":"false"}},_vm._l((_vm.candidateIds),function(candidateId){return _c('candidate-icon',{key:'cursor-' + candidateId,staticClass:"shadow-lg",staticStyle:{"pointer-events":"none"},attrs:{"uid":_vm.uid,"candidate-id":candidateId,"show-name":true,"show-match-percent":true,"show-position":true,"opaque":true,"position":_vm.getCandidatePosition(candidateId),"small":_vm.candidateSize === 'small',"draggable":"false"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }